export const STOREFRONTS_LEGACY_ORG_UNITS_QUERY_KEY = "storefronts-legacy-org-units";
export const STOREFRONTS_ORG_UNIT_LOGO_INFO_QUERY_KEY = "storefronts-org-unit-logo-info";
export const STOREFRONTS_ORG_UNIT_LOGO_QUERY_KEY = "storefronts-org-unit-logo";
export const STOREFRONTS_WELCOME_MESSAGE_QUERY_KEY = "storefronts-welcome-message";
export const STOREFRONTS_QUERY_KEY = "storefronts";
export const STOREFRONTS_SECURITY_GROUPS_QUERY_KEY = "storefronts-security-groups";
export const STOREFRONTS_GROUPS_QUERY_KEY = "storefronts-groups";
export const STOREFRONTS_GROUP_USERS_QUERY_KEY = "storefronts-group-users";

export const STOREFRONTS_MEMBERS_QUERY_KEY = "storefronts-members";
export const STOREFRONTS_ASSIGNABLE_USERS_QUERY_KEY = "storefronts-assignable-users";
